export default "__VITE_ASSET__DBoa9OJX__"